export const SEEN_TAB_NAME = 'SEEN';
